export const syndicationApiMap = {
  communityId: 'community_id',
  communityIds: 'community_ids',
  communityName: 'community_name',
  id: 'id',
  isEnabled: 'is_enabled',
  isMixed: 'is_mixed',
  name: 'name',
  subscriptions: 'subscriptions',
};

export const sortColumnMap = {
  communityId: 'community_id',
  propertyId: 'property_id',
  property: 'property_name',
};

export const getQueryString = (params) => {
  const PAGE_OFFSET = 1;
  const {
    page,
    rowsPerPage,
    searchFilter = '',
    sortColumn,
    sortDirection,
  } = params;
  const requestedPage = page + PAGE_OFFSET;
  return `?page=${requestedPage}&per_page=${rowsPerPage}&sort_column=${sortColumnMap[sortColumn]}&sort_direction=${sortDirection}&search_filter=${searchFilter}`;
};

export const normalizePropertiesSyndication = (channels, properties) => {
  const initialData = {
    activeChannels: [],
    communitiesActiveChannelsMap: {},
    defaultChannelSettingsMap: {},
  };

  const channelsData = Object.entries(channels).reduce(
    (channelData, [channelId, channel]) => {
      const {
        activeChannels,
        communitiesActiveChannelsMap,
        defaultChannelSettingsMap,
      } = channelData;

      defaultChannelSettingsMap[channelId] = false;

      const { communityIds } = channel;

      const hasActiveCommunities = communityIds.length > 0;
      if (hasActiveCommunities) {
        activeChannels.push({ channelId, channelName: channel.name });
      }

      communityIds.forEach((communityId) => {
        if (!communitiesActiveChannelsMap[communityId]) {
          communitiesActiveChannelsMap[communityId] = {};
        }
        communitiesActiveChannelsMap[communityId][channelId] = true;
      });

      return channelData;
    },
    initialData
  );

  const {
    activeChannels,
    communitiesActiveChannelsMap,
    defaultChannelSettingsMap,
  } = channelsData;

  const propertiesSyndication = properties.map((property) => {
    const activeCommunityChannels =
      communitiesActiveChannelsMap[property.communityId] || {};
    const activeChannelCount = Object.keys(activeCommunityChannels).length;
    return {
      property: {
        activeChannelCount,
        ...property,
      },
      ...defaultChannelSettingsMap,
      ...activeCommunityChannels,
    };
  });

  return {
    activeChannels,
    propertiesSyndication,
  };
};

export const normalizeSyndicationProperties = (properties) => {
  return properties.map((property) => ({
    id: property[syndicationApiMap.id],
    communityId: property[syndicationApiMap.communityId],
    name: property[syndicationApiMap.name],
  }));
};

export const serializeChannelSubscriptions = (subscriptions) => {
  return Object.entries(subscriptions)
    .map(([id, subscription]) => ({
      id,
      channelName: subscription.name,
      enablePropertyCount: subscription.communityIds?.length || 0,
    }))
    .sort((a, b) => a.channelName.localeCompare(b.channelName));
};

export const normalizeSyndicationCommunities = (communities) => {
  return communities.map((community) => ({
    communityId: community[syndicationApiMap.communityId],
    communityName: community[syndicationApiMap.communityName],
  }));
};

export const normalizeBatchSyndicationResponse = (response) => {
  const normalizedResponse = {};
  Object.entries(response).forEach(([key, value]) => {
    normalizedResponse[key] = {
      isEnabled: value[syndicationApiMap.isEnabled],
      isMixed: value[syndicationApiMap.isMixed],
    };
  });
  return normalizedResponse;
};

export const transformPatchSubscription = (payload) => {
  const transformedList = [
    [[syndicationApiMap.communityIds], payload.communityIds],
    [[syndicationApiMap.subscriptions], payload.subscriptions],
  ].filter(
    ([_apiKeyName, updatedValue]) =>
      updatedValue !== null && updatedValue !== undefined
  );

  return Object.fromEntries(transformedList);
};
